import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { MetaReferenciaRealizado, referenciaRealizadoNotaFiscal, isReferenciaRealizadoPedido, isReferenciaRealizadoNotaFiscal, isReferenciaRealizadoPedidoNotaFiscal } from '../referencia-realizado';

/** Representa o Filter para obter os totais das metas da empresa e dos representantes */
export class MetaFilterTotal implements Filter {
    mes: number;
    ano: number;
    idsRepresentantes: number[] = [];
    idReferenciaRealizado: number;
    referenciaRealizado: MetaReferenciaRealizado;
    statusesPedidos: number[] = [];

    constructor(referenciaRealizado: MetaReferenciaRealizado = referenciaRealizadoNotaFiscal) {
        this.idReferenciaRealizado = referenciaRealizado?.id ?? referenciaRealizadoNotaFiscal.id;
        this.referenciaRealizado = referenciaRealizado ?? referenciaRealizadoNotaFiscal;
    }

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Mês
        if (this.mes) {
            params = params.append('mes', this.mes.toString());
        }
        // Ano
        if (this.ano) {
            params = params.append('ano', this.ano.toString());
        }
        // Representantes
        this.idsRepresentantes?.forEach(idRepresentante => {
            params = params.append('idRepresentante', idRepresentante.toString());
        });
        // Referência Realizado
        if (this.idReferenciaRealizado) {
            params = params.append('referenciaRealizado', this.idReferenciaRealizado.toString());
        }
        // Statuses dos Pedidos
        if (this.isReferenciaRealizadoPedidoNotaFiscal()) {
            this.statusesPedidos?.forEach(statusPedido => params = params.append('statusPedido', statusPedido.toString()));
        } else {
            params = params.delete('statusPedido');
        }

        return params;
    }

    clear() {
        this.mes = null;
        this.ano = null;
        this.idsRepresentantes = [];
        this.statusesPedidos = [];
    }

    /** Verifica se a referência do realizado do filtro é por Pedido */
    isReferenciaRealizadoPedido(): boolean {
        return isReferenciaRealizadoPedido(this.idReferenciaRealizado);
    }

    /** Verifica se a referência do realizado do filtro é por Nota Fiscal */
    isReferenciaRealizadoNotaFiscal(): boolean {
        return isReferenciaRealizadoNotaFiscal(this.idReferenciaRealizado);
    }

    /** Verifica se a referência do realizado do filtro é por Pedido e Nota Fiscal */
    isReferenciaRealizadoPedidoNotaFiscal(): boolean {
        return isReferenciaRealizadoPedidoNotaFiscal(this.idReferenciaRealizado);
    }
}

